<template>
<div class="homeCover">
  <div class="swiper" >
    <div class="swiper-wrapper">
      <div
        class="swiper-slide"
        v-for="(items,indexs) in list"
      >
        <div class="by">
          <div class="bt">{{items.bt}}</div>
          <div class="title">{{items.title}}</div>
          <div class="eng">{{items.eng}}</div>
        </div>
        <img :src="mb" alt="" class="mb">
        <img class="imgUrl"
             v-if="items.url"
             :src="items.url"
        >
      </div>
    </div>
    <div class="swiper-pagination"></div>
  </div>
</div>
</template>

<script>
import Swiper from 'swiper' // js 模块
import 'swiper/css/swiper.css'; // css 模块
export default {
  name: "HomeCover",
  data(){
    return{
      initSwiper:'',
      mb:require('@/assets/home/mb.png'),
      list: [
        {
          url: require('@/assets/banner1.jpg'),
          bt: '致力于环保、专注于安全、守护职业健康、',
          title: '为更多有需要的人提供完善的服务',
          eng: 'Provide perfect services for more people in need'
        },
        {
          url: require('@/assets/banner3.jpg'),
          bt: '致力于环保、专注于安全、守护职业健康、',
          title: '为更多有需要的人提供完善的服务',
          eng: 'Provide perfect services for more people in need'
        },
        {
          url: require('@/assets/banner2.jpg'),
          bt: '致力于环保、专注于安全、守护职业健康、',
          title: '为更多有需要的人提供完善的服务',
          eng: 'Provide perfect services for more people in need'
        },
      ],
    }
  },
  mounted() {
    setTimeout(()=>{
      this.lbSwiper()
    },300)
  },
  methods:{
    // simulateTouch: !touchCapable(),
    lbSwiper() {
      this.initSwiper = new Swiper('.swiper', {
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        // speed: 4000,//设置匀速运行时间
        loop: true,
        initialSlide: 0,
        observer: true,
        observeParents: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
    },
  }
}
</script>
<style>
.swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets {
  width: 100%;
  text-align: center;
}

.swiper-pagination-bullet {
  width: 15px;
  height: 15px;
  text-align: center;
  line-height: 27px;
  font-size: 18px;
  /*color: #C10008 !important;*/
  /*background: #CEEBF9;*/
  /*border: 1px solid #FF2731;*/
  background: #CEEBF9;
  box-sizing: border-box;
  margin: 0 7px;
}

.swiper .swiper-pagination-bullet {
  border-radius: 6px;
}

.swiper .swiper-pagination-bullet-active {
  color: #CEEBF9 !important;
  width: 60px;
  height: 15px;
  background: #CEEBF9!important;
  border: 1px solid #CEEBF9;
  border-radius: 6px;
}
</style>
<style scoped lang="scss">
.homeCover{
  width: 100vw;
  height: 880px;
  margin-top: 85px;
  background: #FFFFFF;
  .swiper {
    width: inherit;
    height: 790px;
    overflow: hidden;
    position: absolute;
    .swiper-slide {
      width: inherit;
      height: inherit;
    }

    .mb{
      width: inherit;
      height: inherit;
      object-fit: cover;
      position: fixed;
      top: 0;
      z-index: 10;
    }
    .by{
      max-width: 1318px;
      min-width: 1180px;
      height: auto;
      display: flex;
      flex-flow: column nowrap;
      position: relative;
      margin: 226px auto;
      z-index: 100;
      .bt{
        max-width: inherit;
        font-weight: 400;
        font-size: 40px;
        line-height: 45px;
        color: #FFFFFF;
      }
      .title{
        max-width: inherit;
        font-weight: 700;
        font-size: 36px;
        line-height: 50px;
        color: #FFFFFF;
        margin-top: 22px;
      }
      .eng{
        max-width: inherit;
        font-weight: 400;
        font-size: 25px;
        line-height: 35px;
        color: #FFFFFF;
        margin-top: 6px;
      }
    }
    .imgUrl {
      width: inherit;
      height: inherit;
      object-fit: cover;
      position: fixed;
      top: 0;
    }

  }
}
</style>
